import { CommonFunctions } from "../static/common-functions";
import { OrderBillDetailsBus } from "./OrderBillDetailsBus";

export class OrderBillUIParam
{
    canSavePaymentInfo: boolean = false;
    data: OrderBillDetailsBus[];
    amountEntered: number;  
    amountCalculated: number;
    billInfoChanged: boolean = false;
    paymentInfoChanged: boolean = false;
    detailInfoChanged: boolean = false;
    get isEqual(): boolean {
        return CommonFunctions.hasNumberValue(this.amountEntered)
            && CommonFunctions.hasNumberValue(this.amountCalculated)
            && this.amountEntered === this.amountCalculated;
    }
    get canSave(): boolean {
        let canSave: boolean = false;
        if (this.detailInfoChanged && this.paymentInfoChanged) {
            canSave = this.isEqual && this.canSavePaymentInfo;
        }
        else if (this.detailInfoChanged) {
            canSave = this.isEqual;
        }
        else if (this.paymentInfoChanged) {
            canSave = this.canSavePaymentInfo;
        }
        else if(this.billInfoChanged){
            canSave = this.isEqual;
        }
        return canSave;
    }
}
